const colors = {
  background: {
    default: "#1c1c1c",  // Elegant black background
    light: "#2c2c2c",    // Slightly lighter black for sections
  },
  header: {
    background: "#ffffff",   // White background for the header
  },
  
  text: {
    main: "#d2ab67",    // Golden typography for a luxurious feel
    focus: "#f8e08e",   // Lighter gold for focused text
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    main: "#1c1c1c",   // Deep black for main text and elements
    focus: "#2c2c2c",  // Slightly lighter black for focused elements
  },

  primary: {
    main: "#d2ab67",   // Rich gold for primary elements
    focus: "#e0b309",  // Slightly darker gold for focus states
  },

  secondary: {
    main: "#2c2c2c",   // Secondary elements using lighter black
    focus: "#3c3c3c",  // Dark grey for focus
  },

  info: {
    main: "#f1c40f",   // Golden info elements
    focus: "#d2ab67",
  },

  success: {
    main: "#82d616",   // Soft green for success (kept as a highlight)
    focus: "#6bb013",
  },

  warning: {
    main: "#fbcf33",   // Golden-yellow for warnings
    focus: "#fac60b",
  },

  error: {
    main: "#ea0606",   // Red for errors to stand out
    focus: "#c70505",
  },

  light: {
    main: "#2c2c2c",   // Light grey-black for background and neutral elements
    focus: "#1c1c1c",
  },

  dark: {
    main: "#1c1c1c",   // Pure black for dark elements
    focus: "#2c2c2c",
  },

  grey: {
    100: "#2c2c2c",   // Light black for subtle elements
    200: "#3c3c3c",
    300: "#4c4c4c",
    400: "#5c5c5c",
    500: "#6c6c6c",
    600: "#7c7c7c",
    700: "#8c8c8c",
    800: "#9c9c9c",
    900: "#acacac",   // Darker grey-black for borders or dividers
  },

  gradients: {
    primary: {
      main: "#d2ab67",   // Gold gradient for key components
      state: "#d2ab67",  // Darker gold for gradient transitions
    },

    secondary: {
      main: "#2c2c2c",   // Black gradient for secondary elements
      state: "#1c1c1c",
    },

    info: {
      main: "#d2ab67",   // Gold info gradients
      state: "#d2ab67",
    },

    success: {
      main: "#17ad37",   // Soft green for success gradients
      state: "#98ec2d",
    },

    warning: {
      main: "#d2ab67",   // Golden-yellow warning gradients
      state: "#fac60b",
    },

    error: {
      main: "#ea0606",   // Red gradients for errors
      state: "#ff667c",
    },

    light: {
      main: "#2c2c2c",   // Dark grey-black for light gradients
      state: "#1c1c1c",
    },

    dark: {
      main: "#1c1c1c",   // Deep black for dark gradients
      state: "#0c0c0c",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#f1c40f",   // Golden primary alerts
      state: "#e0b309",  // Darker gold for border/hover
      border: "#e5d399",
    },

    secondary: {
      main: "#2c2c2c",   // Black alerts for secondary notifications
      state: "#1c1c1c",
      border: "#3c3c3c",
    },

    info: {
      main: "#d2ab67",   // Gold info alerts
      state: "#e0b309",
      border: "#d2ab67",
    },

    success: {
      main: "#82d616",   // Green success alerts
      state: "#6bb013",
      border: "#daf3b9",
    },

    warning: {
      main: "#d2ab67",   
      state: "#fac60b",
      border: "#fef1c2",
    },

    error: {
      main: "#ea0606",   // Red alerts for errors
      state: "#ff3d59",
      border: "#f9b4b4",
    },

    light: {
      main: "#2c2c2c",   // Black-grey alerts for minor notifications
      state: "#1c1c1c",
      border: "#2c2c2c",
    },

    dark: {
      main: "#1c1c1c",   // Deep black for contrast alerts
      state: "#0c0c0c",
      border: "#c2c8d1",
    },
  },

  badgeColors: {
    primary: {
      background: "#d2ab67",   // Golden background for primary badges
      text: "#d2ab67",         // Black text for clarity
    },

    secondary: {
      background: "#2c2c2c",   // Black for secondary badges
      text: "#f1c40f",
    },

    info: {
      background: "#d2ab67",   // Golden info badges
      text: "#1c1c1c",
    },

    success: {
      background: "#cdf59b",   // Light green success badges
      text: "#67b108",
    },

    warning: {
      background: "#fef5d3",   // Soft golden for warnings
      text: "#d2ab67",
    },

    error: {
      background: "#fc9797",   // Light red for error badges
      text: "#bd0000",
    },

    light: {
      background: "#2c2c2c",   // Black for light badges
      text: "#f1c40f",
    },

    dark: {
      background: "#1c1c1c",   // Deep black for dark badges
      text: "#f1c40f",
    },
  },

  inputColors: {
    borderColor: { main: "#d2ab67", focus: "#d2ab67" },  // Gold for input focus borders
    boxShadow: "#f1c40f",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#d2ab67" },  // Gold slider thumb
  },

  circleSliderColors: {
    background: "#2c2c2c",  // Dark grey for sliders
  },

  tabs: {
    indicator: { boxShadow: "#d2ab67" },  // Gold for active tab indicators
  },
};

export default colors;
